<template>
  <div class="publicPlan">
    <!-- <Title
      :datas="[{ text: '计划', id: 123 }]"
      :active="123"
    /> -->
    <!-- <div class="publicPlan_column1">
    </div> -->

    <div class="publicPlan_column2">
      <i
        class="el-icon-s-open"
        style="margin-right: 10px"
      />
      <div style="display: flex;">
        <el-input
          v-model="campaign_name"
          placeholder="请输入名称"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="handleSearch"
        >搜索</el-button>
        <el-button
          type="primary"
          style="margin-left:10px"
          @click="popup = true"
        >添加推广计划</el-button>
      </div>

    </div>

    <div class="publicPlan_main">
      <el-table
        ref="singleTable"
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          property="campaign_name"
          label="名称"
          width="200"
        />
        <el-table-column
          property="campaign_type_text"
          label="计划类型"
          width="200"
        />
        <el-table-column
          property="promoted_object_type_text"
          label="目标类型"
          width="200"
        />

        <el-table-column
          property="daily_budget"
          label="日预算"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.daily_budget / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="total_budget"
          label="总预算"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.total_budget / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="status_text"
          label="状态"
          width="120"
        />
        <el-table-column
          property="speed_mode_text"
          label="模式"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
            >删除</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleUpdate(scope.row)"
            >更新</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div style="display: flex;justify-content: end;padding: 10px 0px;">
        <el-pagination
          style="text-align: center"
          layout="prev, pager, next"
          :total="count"
          :current-page="page"
          @current-change="(page = $event),(getPublicList())"
        />
      </div>

    </div>

    <el-dialog
      title="公共计划"
      :visible.sync="popup"
    >
      <Popup @create="handleAdd" />
    </el-dialog>
  </div>
</template>

<script>
/* import Title from '@/components/Title/index.vue' */
import { getAccountsPlan, updatePlan, deletePlan, addPlan } from '@/api/publicPlan.js'
import enumeration1 from '@/utils/mixins/enumeration.js'
import Popup from './components/popup.vue'
export default {
  components: {
    /* Title, */
    Popup
  },
  mixins: [enumeration1],
  data() {
    return {
      tableData: [],
      count: null,
      loading: false,
      page: 1,
      campaign_name: '',
      page_size: 10,
      popup: false
    }
  },
  async created() {
    this.getPublicList()
  },
  methods: {
    async getPublicList() {
      const obj = { account_id: this.$route.query.account_id, page: this.page, campaign_name: this.campaign_name, page_size: this.page_size }
      this.campaign_name || delete obj.campaign_name
      this.loading = true
      const data = await getAccountsPlan(obj)
      this.loading = false
      this.count = data.data.count
      this.tableData = data.data.list
    },
    async handleSearch() {
      await this.getPublicList()
      this.campaign_name = ''
    },
    async handleUpdate(item) {
      const obj = {
        account_id: item.account_id,
        campaign_name: item.campaign_name,
        campaign_type: item.campaign_type,
        promoted_object_type: item.promoted_object_type,
        daily_budget: item.daily_budget,
        total_budget: item.total_budget,
        speed_mode: item.speed_mode,
        configured_status: item.configured_status,
        campaign_id: item.campaign_id
      }
      updatePlan(item.id, obj).then((data) => {
        console.log(data)
      })
    },
    async handleDelete(item) {
      deletePlan(item.campaign_id, { account_id: item.account_id }).then((data) => {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.getPublicList()
      })
    },
    async handleAdd(item) {
      this.popup = false
      await addPlan({
        campaign_primary_id: item.id,
        account_id: this.$route.query.account_id
      })
      await this.getPublicList()
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="less">
.publicPlan {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  padding-bottom: 60px;
  .publicPlan_column1 {
    padding: 10px 20px;
    border: 1px solid #e6e8ed;
    /* border-top: none; */
    display: flex;
    justify-content: space-around;
    .column1_planButton {
      position: relative;

      .planButton_text {
        margin-left: 15px;
      }
    }

    .column1_timeZone {
      display: flex;
      align-items: center;
    }
  }

  .publicPlan_column2 {
    padding: 10px 20px;
    border: 1px solid #e6e8ed;
    /* border-top: none; */
    display: flex;
    align-items: center;

    .column2_date {
      position: relative;
      margin-left: 12px;
      .date_text {
        padding: 8px 10px;
        display: inline-block;
        border-radius: 22px;
        border: 1px solid #cccaca;
        cursor: pointer;
      }
      .data_data {
        position: absolute;
        top: 118%;
        z-index: 11;
      }
    }
  }

  .publicPlan_main {
    border: 1px solid #e6e8ed;
    border-top: 0px;
    .main_operation {
      display: flex;
    }
    .main_pen {
      &:hover {
        .pen {
          display: inline-block;
        }
      }
      .pen {
        margin-left: 10px;
        display: none;
        cursor: pointer;
      }
      .ken {
        display: inline-block;
        cursor: pointer;
      }
    }

    .plan {
      cursor: pointer;
      font-size: 18px;
      &:hover {
        color: #00c8c8;
      }
    }
  }
}
.Mantle {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 1111;
}
.details {
  height: 100%;
}
.myExhibition {
  min-width: 1180px;
  max-width: 1180px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  right: 0px;
  transform: translateX(1180px);
  transition: all 0.5s;
  z-index: 1111;
  &.active {
    transform: translateX(0px);
  }
}
</style>
